import Navbar from '../../components/header/navBar';
import Background from '../../components/backGround/backGround';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import InputFieldDoc from '../../components/elements/inputFieldDoc';
import '../../common/styles/components/check.scss';
import { useFetchAlternateName } from '../../common/services/liferay/apiLiferayUser';
import Loading from '../../components/elements/loading';

const ForgotPassword = () => {
  const {
    mutate: mutateAlternateName,
    isSuccess: isSuccessAlternateName,
    error: errorAlternateName,
    data: dataAlternateName,
    isPending: isPendingAlternateName,
    reset,
  } = useFetchAlternateName();
  const [statusX, setStatusX] = useState(false);
  const navigate = useNavigate();
  const [historyIndex, setHistoryIndex] = useState<number>(
    window.history.state?.idx || 0
  );

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.target as HTMLFormElement;
    const formData = new FormData(form);
    const formJson = Object.fromEntries(formData.entries());
    statusX &&
      mutateAlternateName({
        identityDocument: formJson.documentonumero as string,
        identityDocumentTypeId: formJson.tipodedoc as string,
      });
  };
  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (isSuccessAlternateName && dataAlternateName) {
      const payload = dataAlternateName;
      navigate('/olvide-contrasena/paso-1---actualizar', {
        state: { payload },
      });
    }
    if (errorAlternateName) {
      const errorMessage = errorAlternateName.message;
      navigate('/olvide-contrasena/error-olvide', {
        state: { error: errorMessage },
      });
    }
  }, [isSuccessAlternateName, dataAlternateName, navigate, errorAlternateName]);

  useEffect(() => {
    const handlePopState = () => {
      const currentIndex = window.history.state?.idx || 0;

      if (currentIndex < historyIndex) {
        console.log('Retrocediendo en el historial');
        // Lógica para retroceder
      } else if (currentIndex > historyIndex) {
        console.log('Avanzando en el historial');
        // Lógica para avanzar
        window.history.back();
      }

      setHistoryIndex(currentIndex);
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [reset]);

  return (
    <>
      <Navbar />
      {isPendingAlternateName && <Loading />}
      <section className="info-h shrot">
        <div className="padding-global">
          <div className="padding-section-large">
            <div className="container-large">
              <div className="banner_grilla">
                <div
                  id="w-node-_4ad00283-b912-c4f1-f6b7-5dfad8616956-b995645b"
                  className="banner_form">
                  <div className="formulario w-form">
                    <form
                      onSubmit={handleSubmit}
                      id="reset-password-form"
                      name="reset-password-form"
                      data-name="Reset Password Form"
                      method="post"
                      noValidate
                      className="form"
                      data-wf-page-id="6722689cb7d2c823b995645b"
                      data-wf-element-id="221eda68-b07c-d36b-9089-84cb7aded835">
                      <div className="title-component is-center">
                        <h2>Reestablecer tu contraseña</h2>
                        <div className="line-title"></div>
                      </div>
                      <div>Ingresa tu documento de identidad</div>
                      <div className="form_grid">
                        <InputFieldDoc setStatusX={setStatusX} />
                      </div>
                      <div className="form_textnota">
                        Te enviaremos por email o mensaje de texto un código
                        para reestablecer contraseña.
                      </div>
                      <input
                        type="submit"
                        data-wait="Please wait..."
                        className="button is-full w-button"
                        value="Continuar"
                      />
                      <a
                        onClick={handleBack}
                        className="button is-large outline is-full w-button">
                        Volver
                      </a>
                    </form>
                    <div className="w-form-done">
                      <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div className="w-form-fail">
                      <div>
                        Oops! Something went wrong while submitting the form.
                      </div>
                    </div>
                  </div>
                  <div className="text-color-white text-size-small text-align-center txt-form">
                    RUC: 20523470761 · Razón Social: SANITAS PERU S.A. - EPS
                  </div>
                  <div className="banner_form-botoner">
                    <div>¿No tienes cuenta?</div>
                    <a href="#" className="button outlinevf w-button">
                      Quiero registrarme
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Background />
    </>
  );
};

export default ForgotPassword;
